import Modal from 'react-modal';
import { defineMessages, injectIntl } from 'react-intl';
import React from 'react';

const messages = defineMessages({
  STARTING_CONVERSATION: {
    id: 'StartCallModal.STARTING_CONVERSATION',
    defaultMessage: 'Sie starten jetzt ein Gespräch mit Ihrem Kunden.',
  },
  NAME_CUSTOMER: {
    id: 'StartCallModal.NAME_CUSTOMER',
    defaultMessage: 'Kundenname',
  },
  SEND_NAME: {
    id: 'StartCallModal.SEND_NAME',
    defaultMessage: 'SMS Nachricht an {phone}<br /> mit dem Sitzungsnamen versenden.',
  },
  SMS: {
    id: 'StartCallModal.SMS',
    defaultMessage: 'Sollten Sie dem Kunden bereits eine Einladung gesendet haben, kann der Kunde den Link aus der Einladung immer wieder verwenden. Der Link bleibt für jeden Kunden immer gleich.',
  },
  SMS_NO_NUMBER: {
    id: 'StartCallModal.SMS_NO_NUMBER',
    defaultMessage: 'Für den Kunden ist keine Telefonnummer angegeben. Geben Sie den Link bitte auf anderem Weg weiter.',
  },
  BUTTON_START_CONVERSATION: {
    id: 'StartCallModal.BUTTON_START_CONVERSATION',
    defaultMessage: 'Gespräch anfangen',
  },
  SEND_EMAIL: {
    id: 'StartCallModal.SEND_EMAIL',
    defaultMessage: 'E-Mail Entwurf im E-Mail-Programm öffnen',
  },
});

const StartCallModalComponent = ({
  open,
  handleModalClose,
  toggleSMS,
  smsActive,
  toggleEmail,
  emailActive,
  handleSuccess,
  customer,
  company,
  intl: { formatMessage },
}) => {
  let textSMSNumber = formatMessage(messages.SMS);
  let sendSMS = true;

  if (!customer.deleted && !customer.phone) {
    textSMSNumber = formatMessage(messages.SMS_NO_NUMBER);
    sendSMS = false;
  }

  Modal.setAppElement('#app');

  return (
  <Modal
    contentLabel="Modal"
    isOpen={open}
    onRequestClose={handleModalClose}
    closeTimeoutMS={0}
    shouldCloseOnOverlayClick
    className="lh-modal modal-start-call"
    style={{
      overlay: {
        zIndex: 20000000,
        backgroundColor: 'rgba(15, 23, 42, 0.75)',
      },
      content: {
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: '16px',
        color: 'var(--text-primary)',
      }
    }}
  >
    <i className="fa fa-close close-icon" onClick={handleModalClose} style={{ color: 'var(--text-secondary)', cursor: 'pointer', position: 'absolute', top: '16px', right: '16px', fontSize: '20px' }} />
    <h3 style={{ color: 'var(--text-primary)', marginTop: '0', marginBottom: '20px', fontSize: '20px', fontWeight: '600' }}>{formatMessage(messages.STARTING_CONVERSATION)}</h3>
    <p style={{ color: 'var(--text-secondary)', fontSize: '15px', marginBottom: '24px' }}>{formatMessage(messages.NAME_CUSTOMER)}: <strong style={{ color: 'var(--text-primary)' }}>{customer.name}</strong></p>
    
    {sendSMS &&
      <div className="checkbox" style={{ marginBottom: '16px' }}>
        <label style={{ color: 'var(--text-primary)', fontSize: '14px', display: 'flex', alignItems: 'flex-start', cursor: 'pointer' }}>
          <input type="checkbox" onChange={toggleSMS} checked={smsActive} style={{ marginTop: '4px', marginRight: '10px' }} />
          <span dangerouslySetInnerHTML={{ __html: formatMessage(messages.SEND_NAME, { phone: customer.deleted || customer.phone }) }} />
        </label>
      </div>
    }
    <div className="checkbox" style={{ marginBottom: '24px' }}>
      <label style={{ color: 'var(--text-primary)', fontSize: '14px', display: 'flex', alignItems: 'flex-start', cursor: 'pointer' }}>
        <input type="checkbox" onChange={toggleEmail} checked={emailActive} style={{ marginTop: '4px', marginRight: '10px' }} />
        <span>{formatMessage(messages.SEND_EMAIL)}</span>
      </label>
    </div>
    
    {textSMSNumber && (
      <p style={{ color: 'var(--text-muted)', fontSize: '13px', fontStyle: 'italic', marginBottom: '24px' }}>
        {textSMSNumber}
      </p>
    )}
    
    <button
      type="submit"
      className="lh-btn lh-btn-primary btn-lg lh-btn-block start-call"
      onClick={handleSuccess}
      style={{ width: '100%', padding: '12px', fontSize: '16px', fontWeight: 'bold' }}
    >
      {formatMessage(messages.BUTTON_START_CONVERSATION)}
    </button>
  </Modal>);
};

export default injectIntl(StartCallModalComponent);
